import { useTranslations } from "@jugl-web/utils";
import { PlainButton } from "@jugl-web/ui-components/cross-platform";
import { useRef, useState } from "react";
import {
  ManageServiceDrawer,
  ManageServiceDrawerRefState,
} from "@jugl-web/domain-resources/orders/components/ManageServiceDrawer";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { ReactComponent as PlusIcon } from "./assets/plus.svg";

export const ItemsFormAddItem = () => {
  const { t } = useTranslations();
  const { entity } = useEntitySelectedProvider();
  const selectedServicesRef = useRef<ManageServiceDrawerRefState>(null);
  const [isServicesDrawerOpen, setIsServicesDrawerOpen] = useState(false);

  const { addInventoryItem, customErrors, setCustomErrors } =
    useInvoicesItemFormPageContext();

  return (
    <>
      <div className="pl-4 pt-4">
        <PlainButton
          className="bg-grey-200 text-dark-600 font-secondary flex items-center gap-1.5 rounded-lg px-4 py-3 text-sm"
          onClick={() => {
            setIsServicesDrawerOpen(true);
          }}
        >
          <PlusIcon />
          {t({
            id: "invoices.item.add-item-service",
            defaultMessage: "Add Item/Service",
          })}
        </PlainButton>
      </div>

      <ManageServiceDrawer
        ref={selectedServicesRef}
        currency={entity.currency}
        entityId={entity.id}
        isOpen={isServicesDrawerOpen}
        onRequestClose={() => setIsServicesDrawerOpen(false)}
        items={[]}
        invoiceId={undefined}
        onSubmit={(items, itemsQty) => {
          const errorsCopy = { ...customErrors };
          delete errorsCopy.items;
          setCustomErrors(errorsCopy);
          items.forEach((item) => {
            addInventoryItem(item, itemsQty?.[item.id] ?? 1);
          });
        }}
        headerEndContent={
          <PlainButton
            onClick={() => {
              // setIsAddProductFormOpen(true);
            }}
            className="p-4 pr-0"
          >
            <div className="bg-grey-100 flex h-[40px] w-[40px] items-center justify-center rounded-lg active:brightness-95">
              Plus icon
            </div>
          </PlainButton>
        }
      />
    </>
  );
};
